// ── TonightTogether dismissed-suggestions sync ──────────────────────────────
// "Wait up for X" / near-miss suggestions are DERIVED (a friend's stale
// watchlist row keeps surfacing long after they stopped watching), so users
// clear the clutter by dismissing individual show suggestions. Was localStorage-
// only (nextep_tonight_dismissed_<uid>), so clearing it on one device left the
// same stale suggestions reappearing on another (2026-08-21 audit). Same shape
// as coachmarks: localStorage first, profiles.ui_prefs.tonight_together_dismissed
// as the durable source of truth, synced in on profile load.
import { safeStorage } from './safeStorage'
import { supabase } from './supabase'

const KEY = (uid) => `nextep_tonight_dismissed_${uid}`

export function getTonightTogetherDismissed(uid) {
  if (!uid) return new Set()
  try { return new Set(JSON.parse(safeStorage.get(KEY(uid)) || '[]')) } catch { return new Set() }
}

export function dismissTonightTogether(uid, showId) {
  if (!uid) return new Set()
  const next = getTonightTogetherDismissed(uid)
  next.add(showId)
  try { safeStorage.set(KEY(uid), JSON.stringify([...next])) } catch { /* non-fatal */ }
  try { supabase.rpc('mark_tonight_together_dismissed', { p_show_id: String(showId) }).then(() => {}, () => {}) } catch { /* non-fatal */ }
  return next
}

// Called once when the profile loads (useAuth.jsx) — merges the account's
// server-side dismissed set into this device's localStorage.
export function syncTonightTogetherDismissedFromProfile(profile) {
  const remote = profile?.ui_prefs?.tonight_together_dismissed
  if (!Array.isArray(remote) || !remote.length || !profile?.id) return
  const local = getTonightTogetherDismissed(profile.id)
  const merged = new Set([...local, ...remote])
  try { safeStorage.set(KEY(profile.id), JSON.stringify([...merged])) } catch { /* non-fatal */ }
}
